module.exports = __webpack_public_path__ + "static/egsepehr-cover-4512a507671c8eda32c630004c4afca1.jpg";